import { Flex, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'

interface BankConnectionDetailsProps {
  accountName?: string
  customAccountName?: string | null
  iban?: string
  accountNo?: number
}

export const BankConnectionDetails = ({
  accountName,
  customAccountName,
  iban,
  accountNo,
}: BankConnectionDetailsProps): ReactElement | null => {
  if (!accountName && !iban && !accountNo) {
    return null
  }

  return (
    <Flex flexDirection="column" gap={Spacing.S4}>
      {accountName && (
        <Text variant="bodySM" colorVariant="discreet">
          {accountName}
        </Text>
      )}
      {customAccountName && (
        <Text variant="bodySM" colorVariant="discreet">
          {customAccountName}
        </Text>
      )}
      {iban && (
        <Text variant="bodySM" colorVariant="discreet">
          {iban}
        </Text>
      )}
      {accountNo && (
        <Text variant="bodySM" colorVariant="discreet">
          {accountNo}
        </Text>
      )}
    </Flex>
  )
}
